'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export interface RouterPush {
	(pathname: string, queryParams?: Record<string, string | undefined | null>): void;
}

export function useRouterPush() {
	const router = useRouter();
	const currentParams = useSearchParams();

	return useCallback(
		(pathname: string, queryParams: Record<string, string | undefined | null> = {}) => {
			const params = new URLSearchParams(currentParams?.toString());

			// Merge new params
			Object.entries(queryParams).forEach(([key, value]) => {
				if (value === undefined || value === null) {
					params.delete(key);
				} else {
					params.set(key, value);
				}
			});

			const queryString = params.toString();
			return router.push(queryString ? `${pathname}?${queryString}` : pathname);
		},
		[router, currentParams],
	);
}
